<div class="placeholder-page-container">
    <h2 *scText="rendering.fields.header"> </h2> <br/>
</div>